import React, { useState } from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const FaQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const arrowStyle = { width: "20px", height: "20px", flexShrink: 0 };

  const faqs = [
    {
      question: "What is WhatsApp Automation?",
      answer:
        "WhatsApp Automation is a tool that helps businesses send instant, automated messages to their customers on WhatsApp. It allows you to respond to queries, share updates, and guide users through pre-set conversation flows without manual effort. This saves time, improves customer engagement, and ensures that every message reaches the right person at the right time."
    },

    {
      question: "What is Bulk Messaging on WhatsApp?",
      answer:
        "Bulk Messaging on WhatsApp is a feature that lets you send messages to a large number of contacts at once, without sending them individually. It’s perfect for sharing updates, promotions, or announcements quickly and efficiently. With bulk messaging, you can save time, reach more people, and maintain consistent communication with your audience."
    },

    {
      question:
        "Is WhatsApp Bulk Messaging legal and compliant with WhatsApp terms of service?",
      answer:
        " Yes, WhatsApp bulk messaging can be legal and compliant if done correctly. Using the official WhatsApp Business API and following WhatsApp’s rules—like obtaining consent from recipients and avoiding spam—ensures compliance. Our tool is designed to help you send messages responsibly, keeping your campaigns safe, effective, and aligned with WhatsApp’s terms of service.",
    },

    {
      question: "Can I Automate Messages on WhatsApp?",
      answer:
        "Yes, you can easily Automate WhatsApp Messages using the WhatsApp Business App or WhatsApp Business API. The WhatsApp Business App allows Automation of Welcome and Away Messages, while the API enables automation of common customer queries and notifications such as order confirmations and payment reminders."
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="container-fluid d-flex flex-column"
      style={{ background: "#ffffff" }}
    >
      <div className="row mt-4 mb-5">
        <div className="col-lg-3 d-none d-lg-block"></div>
        <div className="col-12 col-lg-6 px-3 px-md-4">
          <h2 className="text-center text-black mt-5 mb-4 fs-4">
            Frequently Asked Questions
          </h2>

          <div className="row ">
            <div className="col-12 p-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                  <div
                    key={index}
                    onClick={() => toggleFAQ(index)}
                    style={{
                      background: isOpen
                        ? "#EFEFEF"
                        : "#D9D9D9",
                      borderRadius: "12px",
                      padding: "20px 18px",
                      marginBottom: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "18px",
                          minWidth: "200px",
                          color: isOpen ? "#000000" : "#000000",
                          fontWeight: isOpen ? "600" : "400",
                        }}
                      >
                        {faq.question}
                      </p>

                      {isOpen ? (
                        <FiChevronUp style={arrowStyle} color="#000000" />
                      ) : (
                        <FiChevronDown style={arrowStyle} color="#000000e0"/>
                      )}
                    </div>

                    {isOpen && (
                      <p
                        style={{
                          fontSize: "15px",
                          color: "#6F7D98",
                          marginTop: "10px",
                          lineHeight: "1.5",
                          maxWidth: "85%"
                        }}
                      >
                        {faq.answer}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-lg-3 d-none d-lg-block"></div>
      </div>
    </div>
  );
};

export default FaQ;